// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"40":"16fafb9162487eb1","882":"52365f248a7bac58","988":"98827242992c6382"}[chunkId] + ".js";
};